import { render, staticRenderFns } from "./AccountSettingPreferences.vue?vue&type=template&id=cc3ffa3a&"
import script from "./AccountSettingPreferences.vue?vue&type=script&lang=js&"
export * from "./AccountSettingPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports